module.exports = __webpack_public_path__ + "img/RF-06.9636a905.jpg";